import { FC } from 'react';
import { NudosButton, NudosGenericModal } from '../../../../components/NudosComponents';
import { ISkuDuplicate } from '../../../../types/products';
import { Link } from 'react-router-dom';
import { IconWarning } from '../../../../assets/DesignSystem/SVGComponents';

import './DuplicateSkuNoticeModal.scss';

interface IDuplicateSkuNoticeModal {
  skuDuplicate: ISkuDuplicate;
  forceProductCreation: () => void;
  closeModal: () => void;
  loadingForceCreation: boolean;
  categoryId: string;
}

const DuplicateSkuNoticeModal: FC<IDuplicateSkuNoticeModal> = ({
  skuDuplicate,
  forceProductCreation,
  loadingForceCreation,
  closeModal,
  categoryId
}: IDuplicateSkuNoticeModal) => {
  return (
    <NudosGenericModal
      modalContent={
        <div id="duplicateSkuNoticeModal">
          <div className="iconContainer">
            <div className="iconBox">
              <IconWarning className="scaleWaningIcon" />
            </div>
          </div>
          <div className="skuTitle">Ya existe un producto en catálogo con el SKU </div>
          <Link
            target="_blank"
            rel="noopener noreferrer"
            className="skuLink"
            to={`/catalog/create-product/${categoryId}?productId=${skuDuplicate.data.productId}&sendToCatalog=true`}
          >
            {skuDuplicate?.data?.SKU}
          </Link>
          <div className="skuQuestion">¿Seguro que deseas continuar?</div>
          <div className="buttonsContainer">
            <NudosButton
              isButtonDisabled={loadingForceCreation}
              componentSize="small"
              buttonText="Cancelar y continuar editando"
              colorPalette="secondary"
              handleClick={closeModal}
            />
            <NudosButton
              isButtonLoading={loadingForceCreation}
              isButtonDisabled={loadingForceCreation}
              componentSize="small"
              buttonText="Guardar de todas formas"
              handleClick={forceProductCreation}
            />
          </div>
        </div>
      }
    />
  );
};

export default DuplicateSkuNoticeModal;
